module.exports = __webpack_public_path__ + "static/media/educationmain.a8d60ca9.jpg";